import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const ModalDetailsMembership = ({ opne, setOpen, membershipData }) => {
  return (
    <Dialog open={opne} maxWidth="sm" fullWidth>
      <DialogTitle>
        Información de membresía {membershipData?.planName ?? ""}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Membresía:</Typography>
              <Typography>{membershipData?.planName ?? "Sin dato"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Costo:</Typography>
              <Typography>
                ${membershipData?.price ?? "Sin dato"}
                {membershipData?.currency ?? "---"}
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Membresía asignada a:</Typography>
              <Typography>
                {membershipData?.typeUser === "user"
                  ? "Runner"
                  : membershipData?.typeUser === "provider"
                    ? "Prestador de servicio"
                    : "---"}
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Rutas permitidas:</Typography>
              <Typography>
                {membershipData?.routeLimit ?? "---"} rutas.
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Período de pago:</Typography>
              <Typography>
                {membershipData?.billingCycle === "month"
                  ? "Mensual"
                  : membershipData?.billingCycle === "year"
                    ? "Anual"
                    : membershipData?.billingCycle === "week"
                      ? "Semanal"
                      : membershipData?.billingCycle === "day"
                        ? "Diario"
                        : "---"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Descripción:</Typography>
              {membershipData?.description &&
                membershipData?.description.map((description, index) => (
                  <Typography key={index}>{description}</Typography>
                ))}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDetailsMembership;
